import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.b6p_1 = partyId;
        this.c6p_1 = playerId;
        this.d6p_1 = name;
        this.e6p_1 = email;
        this.f6p_1 = badge;
        this.g6p_1 = callSignAdjective;
        this.h6p_1 = callSignNoun;
        this.i6p_1 = imageURL;
        this.j6p_1 = avatarType;
        this.k6p_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.b6p_1.toString() + ', playerId=' + this.c6p_1.toString() + ', name=' + this.d6p_1 + ', email=' + this.e6p_1 + ', badge=' + this.f6p_1.toString() + ', callSignAdjective=' + this.g6p_1 + ', callSignNoun=' + this.h6p_1 + ', imageURL=' + toString(this.i6p_1) + ', avatarType=' + toString(this.j6p_1) + ', unvalidatedEmails=' + toString(this.k6p_1) + ')';
      }
      hashCode() {
        var result = this.b6p_1.hashCode();
        result = imul(result, 31) + this.c6p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e6p_1) | 0;
        result = imul(result, 31) + this.f6p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.g6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h6p_1) | 0;
        result = imul(result, 31) + hashCode(this.i6p_1) | 0;
        result = imul(result, 31) + hashCode(this.j6p_1) | 0;
        result = imul(result, 31) + hashCode(this.k6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.b6p_1.equals(other.b6p_1))
          return false;
        if (!this.c6p_1.equals(other.c6p_1))
          return false;
        if (!(this.d6p_1 === other.d6p_1))
          return false;
        if (!(this.e6p_1 === other.e6p_1))
          return false;
        if (!this.f6p_1.equals(other.f6p_1))
          return false;
        if (!(this.g6p_1 === other.g6p_1))
          return false;
        if (!(this.h6p_1 === other.h6p_1))
          return false;
        if (!equals(this.i6p_1, other.i6p_1))
          return false;
        if (!equals(this.j6p_1, other.j6p_1))
          return false;
        if (!equals(this.k6p_1, other.k6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
